/**
 * /microsoft-login
 *
 * Fallback redirect URI for top-level Microsoft OAuth navigations
 * (e.g. user manually opens the URL, or popup redirect is not caught by
 * auth-popup.html for any reason).
 *
 * The primary popup handler is auth-popup.html:
 *  - MSAL social-login: broadcastResponseToMainFrame() via the MSAL bridge.
 *  - Email-provider OAuth: OAUTH_EMAIL_CALLBACK postMessage fallback.
 *
 * If somehow this page loads in a popup context with an auth code, we send
 * OAUTH_EMAIL_CALLBACK as a last resort so the opener isn't left hanging.
 * If opened as a top-level navigation (not a popup), redirect to login.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMsalInstance } from '../../config/oauth';

export default function MicrosoftLoginRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code   = params.get('code')  ?? '';
    const state  = params.get('state') ?? '';
    const error  = params.get('error') ?? '';

    getMsalInstance()
      .then(() => {
        if (window.opener && !window.opener.closed) {
          // Last-resort fallback: send OAUTH_EMAIL_CALLBACK in case this page
          // was reached during an email-provider OAuth flow.
          if (code || error) {
            window.opener.postMessage(
              { type: 'OAUTH_EMAIL_CALLBACK', code, state, error },
              window.location.origin,
            );
          }
          setTimeout(() => window.close(), 300);
        } else {
          navigate('/login', { replace: true });
        }
      })
      .catch(() => {
        if (window.opener && !window.opener.closed) {
          if (code || error) {
            window.opener.postMessage(
              { type: 'OAUTH_EMAIL_CALLBACK', code, state, error },
              window.location.origin,
            );
          }
          setTimeout(() => window.close(), 300);
        } else {
          navigate('/login', { replace: true });
        }
      });
  }, [navigate]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <p style={{ color: '#6b7280', fontSize: 14 }}>Completing sign-in…</p>
    </div>
  );
}
